import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getModuloByCentral } from './services'

const initialState: any = {
  status: "",
  entradaSelected: null,
  data: []
}

export const actionGetModuloByCentral: any = createAsyncThunk<any, string>(
  "ACTION_GET_MODULO_BY_CENTRAL",
  async (idCentral) => {
    return getModuloByCentral(idCentral)
  }
)

const sliceGetModuloByCentral = createSlice({
  name: "GET_MODULO",
  initialState,
  reducers: {
    actionSelectEntradaModulo: (state, { payload }) => {
      state.entradaSelected = payload
    },
    actionResetModulos: (state) => {
      state.data = []
      state.status = ""
      state.entradaSelected = null
    }
  },
  extraReducers: {
    [actionGetModuloByCentral.pending]: (state, p) => {
      state.status = "loading"
    },
    [actionGetModuloByCentral.fulfilled]: (state, { payload }) => {
      state.status = "success"
      state.data = payload.map((item: any) => {
        const entradas = item?.entradas.reduce((acc: any, item: any) => {
          if (item.tipo === "D") {
            acc.digitais = [...acc.digitais, { ...item }]
          }
          if (item.tipo === "A") {
            acc.analogicas = [...acc.analogicas, { ...item }]
          }
          if (item.tipo === "R") {
            acc.medidores = [...acc.medidores, { ...item }]
          }
          return acc
        }, { digitais: [], analogicas: [], medidores: [] })

        return {
          ...item,
          entradas,
        }
      })

    },
    [actionGetModuloByCentral.rejected]: (state) => {
      state.status = "error"
    },
  }
})

export default sliceGetModuloByCentral.reducer
export const { actionSelectEntradaModulo, actionResetModulos } = sliceGetModuloByCentral.actions